import { render, staticRenderFns } from "./Star.vue?vue&type=template&id=eaa53c82"
import script from "./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports